import React, { useState } from 'react';
import { Users, CheckCircle, Clock, AlertCircle } from 'lucide-react';
import TaskModal from '../components/TaskModal';
import ManageProjectModal from './ManageProjectModal';

function ProjectCard({ project, onUpdate, onUpdateProject, onDelete, employeeData }) {
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [showManageModal, setShowManageModal] = useState(false);
console.log(project)
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-xl font-semibold text-gray-900">
          {project?.projectName || 'Untitled Project'}
        </h3>
      </div>

      <p
  className="text-gray-600 mb-4 truncate-description"
  style={{
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 3, // Adjust the number of lines to show
    WebkitBoxOrient: 'vertical',
  }}
>
  {project?.projectDescription || 'No description available.'}
</p>


      <div className="border-t border-gray-200 pt-4 mb-4">
        <div className="flex items-center gap-2 mb-2">
          <Users className="h-4 w-4 text-gray-400" />
          <span className="text-sm text-gray-600">Team Members</span>
        </div>
        <div className="space-y-2">
          {project?.Employeelist?.length > 0 ? (
            project.Employeelist.map((employee, index) => (
              <div key={index} className="text-sm text-gray-600">
                {employee.employeeName || 'Unnamed'}
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-sm">No employees assigned.</p>
          )}
        </div>
      </div>

      <div className="flex justify-between items-center">
        <button
          onClick={() => setShowTaskModal(true)}
          className="text-blue-600 hover:text-blue-700 text-sm font-medium"
        >
          View Tasks ({project?.Tasks || 0})
        </button>
        <button
          onClick={() => setShowManageModal(true)}
          className="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition-colors"
        >
          Manage Project
        </button>
      </div>

      {showTaskModal && (
        <TaskModal
          project={project}
          onClose={() => setShowTaskModal(false)}
          onUpdate={onUpdate}
        />
      )}

      {showManageModal && (
        <ManageProjectModal
          project={project}
          onClose={() => setShowManageModal(false)}
          onUpdateProject={onUpdateProject}
          onDelete={onDelete}
          employeeData={employeeData}
        />
      )}
    </div>
  );
}

export default ProjectCard;
